import React from "react";
import AreaConverter from "./components/AreaConverter";

function App() {
  return (
    <div className="h-screen w-screen overflow-hidden touch-manipulation">
      <AreaConverter />
    </div>
  );
}

export default App;
